import React, { Component } from "react";
import TextArea from "../../components/inputs/text-area";
import "./../lente-pronta.css";

class LenteProntaEtapaQuatro extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.props.onChange({ [event.target.name]: event.target.value });
  }

  render() {
    const { disableFields } = this.props;

    return (
      <div>
        <div className="row">
          <div className="col-12">
            <TextArea
              id="textarea-observacao"
              name="observacao"
              label="Observação"
              aria="Observação"
              width="100%"
              autocomplete="off"
              value={this.props.observacao || ""}
              onChange={this.handleChange}
              disabled={disableFields}
              readOnly={disableFields}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default LenteProntaEtapaQuatro;
